<template>
  <iframe
    v-if="jwt.length > 0"
    :src="widgetUrl"
  />
</template>

<script>
  import CryptoJS from 'crypto-js'
  import { base64url } from '~/helpers/crypto'
  import Api from '~/store/idonia-api/api'

  export default {
    name: 'dialog-ascires-form',
    props: {
      file: {
        type: Object,
        default: () => ({})
      },
      newRequest: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        jwt: '',
        clientData: { guarantorCode: null, clientId: null, issuerOfPatientId: null, environment: null }
      }
    },
    async mounted () {
      await this._extractClientData()
      this.jwt = await this._generateJwt()
    },
    methods: {
      async _generateJwt () {
        let apiKey, apiSecret
        try {
          const { data: apiKeyData } = await Api.getV2('api-key')
          if (apiKeyData && !apiKeyData.revokedDatetime) {
            apiKey = apiKeyData.apiKey
          }

          const { data: apiSecretData } = await Api.getV2('api-key/' + apiKey)
          if (apiSecretData.apiSecret.length > 0) {
            apiSecret = apiSecretData.apiSecret
          }

          const header = {
            'alg': 'HS256',
            'typ': 'JWT'
          }

          const stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header))
          const encodedHeader = base64url(stringifiedHeader)

          const now = Math.round(new Date().getTime() / 1000)

          const data = {
            'sub': apiKey,
            'iat': now,
            'exp': new Date(now + 4 * 60 * 60).getTime()
          }

          const stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify(data))
          const encodedData = base64url(stringifiedData)

          const token = `${encodedHeader}.${encodedData}`

          let signature = CryptoJS.HmacSHA256(token, apiSecret)
          signature = base64url(signature)

          return `${token}.${signature}`
        } catch (error) {
          console.error(error)
        }

        return {
          apiKey,
          apiSecret
        }
      },
      async _extractClientData () {
        return new Promise((resolve, reject) => {
          this.file.platform_tags.forEach(item => {
            if (item.startsWith('ascires_form:')) {
              const chunks = item.split(':')
              if (chunks[1].includes('-')) {
                const dataChunk = chunks[1].split('-')
                if (this.clientData.hasOwnProperty(dataChunk[0])) {
                  this.clientData[dataChunk[0]] = dataChunk[1]
                }
              }
            }
          })

          resolve(this.clientData)
        })
      }
    },
    computed: {
      widgetUrl () {
        let url = `${this.$config.connectCloudUrl}/widget/ascires.html?t=${this.jwt}&parent_id=${this.file.id_file}`

        if (this.newRequest) {
          if (this.clientData.guarantorCode) {
            url += `&guarantorCode=${this.clientData.guarantorCode}`
          }

          if (this.clientData.clientId) {
            url += `&clientId=${this.clientData.clientId}`
          }

          if (this.clientData.issuerOfPatientId) {
            url += `&issuerOfPatientId=${this.clientData.issuerOfPatientId}`
          }

          if (this.clientData.environment === 'pre') {
            url += '&env=pre'
          }
        }

        url += this.newRequest ? '#/' : '#/continue'

        return url
      }
    }
  }
</script>

<style lang="scss" scoped>
iframe {
  width: 100%;
  min-height: 690px;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/common/dialog/types/DialogAsciresForm.vue